import { initBookingWidgets } from './modules/booking-widget.js';
import { initAvailability }   from './modules/availability.js';
import { initMenuOverlay }    from './modules/menu.js';
import { initMarquees }       from './modules/marquee.js';
import { initCarousels }      from './modules/carousel.js';
import { initFullwidthCarousels } from './modules/fullwidth-carousel.js';
import { initChildCarousels }  from './modules/child-carousel.js';
import { initRoomDetails }     from './modules/room-detail.js';
import { initFaqs }           from './modules/faqs.js';
import { initBackToTop }      from './modules/back-to-top.js';
import { initReveal }         from './modules/reveal.js';
import { initGuestAdvisory }  from './modules/guest-advisory.js';

(function($){
    'use strict';
    (() => {
        class App {
            static init() {
                initMenuOverlay();
                initMarquees();
                initCarousels();
                initFullwidthCarousels();
                initChildCarousels();
                initRoomDetails();
                initFaqs();
                initBackToTop();
                initBookingWidgets();
                initAvailability();
                initReveal();
                initGuestAdvisory();
            }
        }

        $(document).ready(() => {
            App.init();
        });
    })();
})(window.jQuery);
